import {Component, Input, OnInit} from '@angular/core';
import {ModalController, ViewWillEnter} from '@ionic/angular';
import {TranslateService} from '@ngx-translate/core';
import {UserService} from '../../../../_services';

@Component({
  selector: 'app-why-user-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss'],
})
export class ReportsComponent implements OnInit {

  @Input() reports = [];

  constructor(
    public translate: TranslateService,
    public modalController: ModalController) {
  }

  ngOnInit() {
  }

  gotToTop() {
    const myDiv = window.document.querySelector('#reportsHistory') as HTMLInputElement;
    myDiv.scroll({top: 0, behavior: 'smooth'});
  }
}
